// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1wTtR","actionsCol":"EnrolledClinics_actionsCol__aCuMz"};